import React from 'react';
import { cn } from './utils';

export const Card = React.forwardRef(({ className, ...props }, ref) => <div ref={ref}
  className={cn('sc-rounded-lg sc-border sc-border-solid sc-border-border sc-bg-background sc-text-foreground sc-shadow-sm', className)} {...props} />);
Card.displayName = 'Card';
export const CardContent = ({ className, ...props }) => <div className={cn('sc-p-5', className)} {...props} />;
